import { defineComponent as W, ref as y, inject as H, computed as z, watch as _, onMounted as M, watchEffect as N, onBeforeUnmount as A, h as R } from "vue";
import { isImageSupportNativeLazy as F } from "./ghl-ui.es854.js";
import { observeIntersection as V } from "./ghl-ui.es855.js";
import { tagInjectionKey as w } from "./ghl-ui.es300.js";
import { avatarGroupInjectionKey as G } from "./ghl-ui.es856.js";
import K from "./ghl-ui.es857.js";
import D from "./ghl-ui.es842.js";
import $ from "./ghl-ui.es843.js";
import { createKey as U } from "./ghl-ui.es692.js";
import { useThemeClass as X } from "./ghl-ui.es844.js";
import { color2Class as Y } from "./ghl-ui.es858.js";
import { resolveSlot as q, resolveWrappedSlot as J } from "./ghl-ui.es847.js";
import Q from "./ghl-ui.es859.js";
import Z from "./ghl-ui.es726.js";
const ee = Object.assign(Object.assign({}, $.props), {
  size: [String, Number],
  src: String,
  circle: {
    type: Boolean,
    default: void 0
  },
  objectFit: String,
  round: {
    type: Boolean,
    default: void 0
  },
  bordered: {
    type: Boolean,
    default: void 0
  },
  onError: Function,
  fallbackSrc: String,
  intersectionObserverOptions: Object,
  lazy: Boolean,
  onLoad: Function,
  renderPlaceholder: Function,
  renderFallback: Function,
  imgProps: Object,
  /** @deprecated */
  color: String
}), he = W({
  name: "Avatar",
  props: ee,
  setup(t) {
    const { mergedClsPrefixRef: l, inlineThemeDisabled: v } = D(t), a = y(!1);
    let d = null;
    const h = y(null), s = y(null), S = () => {
      const { value: e } = h;
      if (e && (d === null || d !== e.innerHTML)) {
        d = e.innerHTML;
        const { value: o } = s;
        if (o) {
          const { offsetWidth: n, offsetHeight: r } = o, { offsetWidth: i, offsetHeight: x } = e, O = 0.9, E = Math.min(n / i * O, r / x * O, 1);
          e.style.transform = `translateX(-50%) translateY(-50%) scale(${E})`;
        }
      }
    }, g = H(G, null), b = z(() => {
      const { size: e } = t;
      if (e)
        return e;
      const { size: o } = g || {};
      return o || "medium";
    }), L = $("Avatar", "-avatar", K, Q, t, l), c = H(w, null), f = z(() => {
      if (g)
        return !0;
      const { round: e, circle: o } = t;
      return e !== void 0 || o !== void 0 ? e || o : c ? c.roundRef.value : !1;
    }), p = z(() => g ? !0 : t.bordered || !1), u = (e) => {
      var o;
      if (!j.value)
        return;
      a.value = !0;
      const { onError: n, imgProps: r } = t;
      (o = r == null ? void 0 : r.onError) === null || o === void 0 || o.call(r, e), n && n(e);
    };
    _(() => t.src, () => a.value = !1);
    const P = z(() => {
      const e = b.value, o = f.value, n = p.value, { color: r } = t, { self: { borderRadius: i, fontSize: x, color: O, border: E, colorModal: B, colorPopover: k }, common: { cubicBezierEaseInOut: I } } = L.value;
      let C;
      return typeof e == "number" ? C = `${e}px` : C = L.value.self[U("height", e)], {
        "--n-font-size": x,
        "--n-border": n ? E : "none",
        "--n-border-radius": o ? "50%" : i,
        "--n-color": r || O,
        "--n-color-modal": r || B,
        "--n-color-popover": r || k,
        "--n-bezier": I,
        "--n-merged-size": `var(--n-avatar-size-override, ${C})`
      };
    }), m = v ? X("avatar", z(() => {
      const e = b.value, o = f.value, n = p.value, { color: r } = t;
      let i = "";
      return e && (typeof e == "number" ? i += `a${e}` : i += e[0]), o && (i += "b"), n && (i += "c"), r && (i += Y(r)), i;
    }), P, t) : void 0, j = y(!t.lazy);
    M(() => {
      if (F)
        return;
      let e;
      const o = N(() => {
        e == null || e(), e = void 0, t.lazy && (e = V(s.value, t.intersectionObserverOptions, j));
      });
      A(() => {
        o(), e == null || e();
      });
    });
    const T = y(!t.lazy);
    return {
      textRef: h,
      selfRef: s,
      mergedRoundRef: f,
      mergedClsPrefix: l,
      fitTextTransform: S,
      cssVars: v ? void 0 : P,
      themeClass: m == null ? void 0 : m.themeClass,
      onRender: m == null ? void 0 : m.onRender,
      hasLoadError: a,
      handleError: u,
      shouldStartLoading: j,
      loaded: T,
      mergedOnLoad: (e) => {
        var o;
        const { onLoad: n, imgProps: r } = t;
        n == null || n(e), (o = r == null ? void 0 : r.onLoad) === null || o === void 0 || o.call(r, e), T.value = !0;
      }
    };
  },
  render() {
    var t, l;
    const { $slots: v, src: a, mergedClsPrefix: d, lazy: h, onRender: s, mergedOnLoad: S, shouldStartLoading: g, loaded: b, hasLoadError: L } = this;
    s == null || s();
    let c;
    const f = !b && !L && (this.renderPlaceholder ? this.renderPlaceholder() : (l = (t = this.$slots).placeholder) === null || l === void 0 ? void 0 : l.call(t));
    return this.hasLoadError ? c = this.renderFallback ? this.renderFallback() : q(v.fallback, () => [
      R("img", { src: this.fallbackSrc, style: { objectFit: this.objectFit } })
    ]) : c = J(v.default, (p) => {
      if (p)
        return R(Z, { onResize: this.fitTextTransform }, {
          default: () => R("span", { ref: "textRef", class: `${d}-avatar__text` }, p)
        });
      if (a) {
        const { imgProps: u } = this;
        return R("img", Object.assign(Object.assign({}, u), { loading: (
          // If interseciton observer options is set, do not use native lazy
          F && !this.intersectionObserverOptions && h ? "lazy" : "eager"
        ), src: F || g || b ? a : void 0, onLoad: S, "data-image-src": a, onError: this.handleError, style: [
          u == null ? void 0 : u.style,
          { objectFit: this.objectFit },
          f ? {
            height: "0",
            width: "0",
            visibility: "hidden",
            position: "absolute"
          } : ""
        ] }));
      }
    }), R(
      "span",
      { ref: "selfRef", class: [`${d}-avatar`, this.themeClass], style: this.cssVars },
      c,
      h && f
    );
  }
});
export {
  ee as avatarProps,
  he as default
};
